import Firebase from "firebase";
// Your web app's Firebase configuration
var firebaseConfig = {
apiKey: "AIzaSyA0-RwpEmfelY95RWyv9dgAELExhm-wKaE",
authDomain: "minomina-aliaddo-com.firebaseapp.com",
databaseURL: "https://minomina-aliaddo-com.firebaseio.com",
projectId: "minomina-aliaddo-com",
storageBucket: "minomina-aliaddo-com.appspot.com",
messagingSenderId: "282537239428",
appId: "1:282537239428:web:9f3c5cbbce1fb3791a33d1",
};
// Initialize Firebase
    export let db = Firebase.initializeApp(firebaseConfig).database();
